var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNccaBanner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.998,
    height: 12.799,
    viewBox: "0 0 15.998 12.799",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 173478",
    transform: "translate(18288 6217)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21280",
    d: "M.615 0h14.768A.726.726 0 0 1 16 .8V12a.726.726 0 0 1-.615.8H.615A.726.726 0 0 1 0 12V.8A.726.726 0 0 1 .615 0z",
    transform: "translate(-18288 -6217)",
    style: {
      fill: "#3b82f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21070",
    d: "M245.749 7.065a2.286 2.286 0 0 0 1.064-1.865 2.286 2.286 0 0 0-1.065-1.868 2.286 2.286 0 0 0 1.065-1.868.277.277 0 0 0-.553 0 1.6 1.6 0 0 1-.028.3h-1.881a1.6 1.6 0 0 1-.028-.3.277.277 0 0 0-.553 0 2.293 2.293 0 0 0 1.065 1.868 2.29 2.29 0 0 0-1.061 1.868 2.286 2.286 0 0 0 1.065 1.868 2.292 2.292 0 0 0-1.065 1.868.277.277 0 0 0 .553 0 1.6 1.6 0 0 1 .028-.3h1.881a1.6 1.6 0 0 1 .028.3.277.277 0 0 0 .553 0 2.3 2.3 0 0 0-1.068-1.871zm-1.3-5h1.693a2.479 2.479 0 0 1-.846.923 2.5 2.5 0 0 1-.846-.923zm.846 1.612a3.528 3.528 0 0 1 .656.607h-1.312a3.526 3.526 0 0 1 .656-.607zm-.839.908h1.678a1.406 1.406 0 0 1 .125.464h-1.925a1.4 1.4 0 0 1 .122-.464zm-.125.765h1.925a1.409 1.409 0 0 1-.125.464h-1.674a1.41 1.41 0 0 1-.122-.464zm.3.765h1.315a3.528 3.528 0 0 1-.656.607 3.527 3.527 0 0 1-.656-.607zm-.187 2.219a2.479 2.479 0 0 1 .846-.923 2.519 2.519 0 0 1 .846.923z",
    transform: "translate(-18530.171 -6215.797)",
    style: {
      fill: "#c5dafb"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 173399",
    transform: "translate(-18281.982 -6213.448)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 145014",
    width: 3.791,
    height: 1.194,
    rx: 0.597,
    transform: "translate(0 4.5)",
    style: {
      fill: "#f4b545"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 145015",
    width: 8.38,
    height: 0.853,
    rx: 0.427,
    style: {
      fill: "#c5dafb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 145016",
    width: 8.38,
    height: 0.853,
    rx: 0.427,
    transform: "translate(0 1.365)",
    style: {
      fill: "#c5dafb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 145018",
    width: 8.38,
    height: 0.853,
    rx: 0.427,
    transform: "translate(0 2.729)",
    style: {
      fill: "#c5dafb"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 145017",
    width: 3.791,
    height: 1.04,
    rx: 0.52,
    transform: "translate(-18277.395 -6215.4)",
    style: {
      fill: "#c5dafb"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNccaBanner);
export default __webpack_public_path__ + "static/media/NCCA-Banner.0ec1eb3f5b7813de45a0f2592e35cd29.svg";
export { ForwardRef as ReactComponent };